import { makeStyles } from '@material-ui/core'

export default makeStyles(theme => ({
    container: {
        position: 'absolute',
        zIndex: 99,
    }
}))
